import { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { varsFromSearch } from "../../shared/personalize";
import type { DemoBundle } from "../../shared/types";
import { api, ApiError } from "../api";
import { setMonitoringTags } from "../monitoring";
import Player from "./Player";

export default function PublicPlayer() {
  const { productSlug = "", demoSlug = "" } = useParams();
  const [params] = useSearchParams();
  const [bundle, setBundle] = useState<DemoBundle | null>(null);
  const [error, setError] = useState<string | null>(null);
  const vars = useMemo(() => varsFromSearch(params), [params]);

  useEffect(() => {
    setMonitoringTags({ product_slug: productSlug, demo_slug: demoSlug });
    api.publicDemo(productSlug, demoSlug)
      .then((b) => { setBundle(b); document.title = `${b.demo.title} | ${b.product.name}`; })
      .catch((e) => setError(e instanceof ApiError && e.status === 404
        ? "This demo isn't available. The link may be old, or the demo was unpublished."
        : "The demo couldn't load. Check your connection and refresh the page."));
  }, [productSlug, demoSlug]);

  if (error) return <div className="center-msg"><p>{error}</p></div>;
  if (!bundle) return <div className="center-msg"><p className="muted">Loading demo…</p></div>;
  return <Player bundle={bundle} mode="live" source={(params.get("src") ?? "").slice(0, 80)} vars={vars} pathParam={params.get("path")} />;
}
